// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { AddendumDTO } from './addendum-dto';
import { CheckoutDTO } from './checkout-dto';
import { DocumentDTO } from './document-dto';
import { OrganizationDTO } from './organization-dto';
import { PreTenancyDocumentDTO } from './pre-tenancy-document-dto';
import { PropertyDTO } from './property-dto';
import { TenancyAccessMode } from './tenancy-access-mode';
import { TenancyAnniversaryDTO } from './tenancy-anniversary-dto';
import { TenancyExpiryDTO } from './tenancy-expiry-dto';
import { TenancyInventoryDTO } from './tenancy-inventory-dto';
import { TenancyOrderDTO } from './tenancy-order-dto';
import { TenancyTransferDTO } from './tenancy-transfer-dto';
import { TenantDTO } from './tenant-dto';
import { UserDTO } from './user-dto';

/**
 * 
 * @export
 * @interface TenancyDTO
 */
export interface TenancyDTO {
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TenancyDTO
     */
    PPM: number;
    /**
     * 
     * @type {PropertyDTO}
     * @memberof TenancyDTO
     */
    property: PropertyDTO;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    endDate?: string;
    /**
     * 
     * @type {Array<TenancyExpiryDTO>}
     * @memberof TenancyDTO
     */
    expiryDates?: Array<TenancyExpiryDTO>;
    /**
     * 
     * @type {Array<TenancyOrderDTO>}
     * @memberof TenancyDTO
     */
    orders?: Array<TenancyOrderDTO>;
    /**
     * 
     * @type {Array<DocumentDTO>}
     * @memberof TenancyDTO
     */
    documents?: Array<DocumentDTO>;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof TenancyDTO
     */
    organization: OrganizationDTO;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    restrictedViewOrganizationId: string;
    /**
     * 
     * @type {TenancyAccessMode}
     * @memberof TenancyDTO
     */
    accessMode?: TenancyAccessMode;
    /**
     * 
     * @type {Array<TenantDTO>}
     * @memberof TenancyDTO
     */
    tenants: Array<TenantDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyDTO
     */
    letOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyDTO
     */
    isNewTenancy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    termType?: TenancyDTOTermTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    scheduledMoveOutDate?: string;
    /**
     * 
     * @type {CheckoutDTO}
     * @memberof TenancyDTO
     */
    checkout?: CheckoutDTO;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    outcomeDeadline?: string;
    /**
     * 
     * @type {UserDTO}
     * @memberof TenancyDTO
     */
    publisherUser: UserDTO;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    legacyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyDTO
     */
    hasExtendedOutcomeDeadline: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyDTO
     */
    topUpEnabled: boolean;
    /**
     * 
     * @type {Array<TenancyAnniversaryDTO>}
     * @memberof TenancyDTO
     */
    anniversaries?: Array<TenancyAnniversaryDTO>;
    /**
     * 
     * @type {Array<TenancyTransferDTO>}
     * @memberof TenancyDTO
     */
    tenancyTransfers?: Array<TenancyTransferDTO>;
    /**
     * 
     * @type {string}
     * @memberof TenancyDTO
     */
    lastEndDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenancyDTO
     */
    closingRemindersEnabled: boolean;
    /**
     * 
     * @type {AddendumDTO}
     * @memberof TenancyDTO
     */
    addendum?: AddendumDTO;
    /**
     * 
     * @type {TenancyInventoryDTO}
     * @memberof TenancyDTO
     */
    inventory?: TenancyInventoryDTO;
    /**
     * 
     * @type {Array<PreTenancyDocumentDTO>}
     * @memberof TenancyDTO
     */
    preTenancyDocuments?: Array<PreTenancyDocumentDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum TenancyDTOTermTypeEnum {
    FIXED = 'FIXED',
    PERIODIC = 'PERIODIC'
}



